document.addEventListener('DOMContentLoaded', () => {
    const stickyBar = document.getElementById('sticky-product');
    if (!stickyBar) return;

    stickyBar.querySelectorAll('.ratings-stars .star-inner').forEach((element) => {
        element.style.width = `${(4.6 / 5) * 100}%`;
    });

    const scrollButton = stickyBar.querySelector('.sticky-product-button');
    if (scrollButton) {
        scrollButton.addEventListener('click', function () {
            const targetId = this.getAttribute('data-scroll-to');
            if (!targetId) return;
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }

    const sections = document.querySelectorAll('#MainContent > .shopify-section');
    let firstSection = null;
    for (const section of sections) {
        if (!section.querySelector('#sticky-product')) {
            firstSection = section;
            break;
        }
    }

    if (!firstSection) return;

    const scrollToId = scrollButton ? scrollButton.getAttribute('data-scroll-to') : null;
    const scrollToSection = scrollToId ? document.getElementById(scrollToId) : null;

    let pastFirstSection = false;
    let targetVisible = false;
    let footerVisible = false;

    const footerSection = document.querySelector('.app-newsletter-class');

    function updateVisibility() {
        stickyBar.style.display = (pastFirstSection && !targetVisible && !footerVisible) ? 'block' : 'none';
    }

    const firstObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            pastFirstSection = !entry.isIntersecting;
            updateVisibility();
        });
    }, { threshold: 0 });

    firstObserver.observe(firstSection);

    if (scrollToSection) {
        const targetObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                targetVisible = entry.isIntersecting;
                updateVisibility();
            });
        }, { threshold: 0 });

        targetObserver.observe(scrollToSection);
    }

    if (footerSection) {
        const footerObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                footerVisible = entry.isIntersecting;
                updateVisibility();
            });
        }, { threshold: 0 });

        footerObserver.observe(footerSection);
    }
});
